import { Link } from 'react-router-dom';
import { latestArticles } from '@/mocks/data';

export default function LatestGridSection() {
  return (
    <section className="bg-background-100 py-10 md:py-14">
      <div className="container-page">
        <div className="mb-8">
          <h2 className="text-2xl md:text-3xl font-light text-foreground-950 tracking-wide">
            最新黑料曝光
          </h2>
          <p className="text-secondary-500 text-sm mt-1 font-light">
            实时追踪网红圈最新翻车事件
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {latestArticles.map((article, index) => (
            <article key={article.id} className="card-dark overflow-hidden group">
              <Link to={`/article/${article.slug}`} className="block cursor-pointer">
                <div className="relative w-full h-[220px] overflow-hidden">
                  <img
                    src={article.image}
                    alt={article.title}
                    title={`${article.title} - 17吃瓜最新黑料`}
                    className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                    loading="lazy"
                  />
                </div>
              </Link>
              <div className="p-5 flex flex-col items-center text-center">
                <Link to={`/article/${article.slug}`} className="cursor-pointer">
                  <h3 className="text-foreground-900 text-base font-medium leading-snug line-clamp-2 mb-3 group-hover:text-primary-400 transition-colors">
                    {article.title}
                  </h3>
                </Link>
                <div className="flex items-center gap-4 mb-3">
                  <span className="text-foreground-300 text-xs">
                    <i className="ri-eye-line mr-1"></i>
                    {article.views >= 10000 ? `${(article.views / 10000).toFixed(0)}万` : article.views}
                  </span>
                  <span className="text-foreground-300 text-xs">
                    <i className="ri-chat-1-line mr-1"></i>
                    {article.comments >= 10000 ? `${(article.comments / 10000).toFixed(0)}万` : article.comments}
                  </span>
                </div>
                <Link
                  to={`/article/${article.slug}`}
                  className={`w-4/5 text-center text-sm font-medium py-2.5 rounded-full transition-all cursor-pointer whitespace-nowrap ${
                    index === 0
                      ? 'bg-primary-500 text-foreground-50 hover:bg-primary-400'
                      : 'border border-secondary-400 text-foreground-700 hover:border-foreground-600 hover:text-foreground-950'
                  }`}
                >
                  查看详情
                </Link>
                <span className="text-secondary-600 text-xs mt-3">{article.time}</span>
              </div>
            </article>
          ))}
        </div>

        <div className="mt-8 text-center">
          <Link
            to="/category/wanghong-heiliao"
            className="btn-outline inline-flex items-center gap-2 cursor-pointer"
          >
            加载更多黑料
            <i className="ri-arrow-down-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}